import React from 'react'
import { observer } from 'mobx-react-lite'

import { ImportScreen } from '../../ImportScreen'
import { WbProductImportTable } from '../../WbProductImportTable'

import { useWbAccount } from '../../../hooks/routeHooks'
import { useApi, useStore } from '../../../hooks/storeHook'

import { WbProductsTableData } from '../../../store/productStore'

import { WbProductColumnId } from '../../../types/wbColumns'
import { WbProductModel } from '../../../server/mpsklad_core/Models/WbProductModel'
import { WbAccountModel } from '../../../server/mpsklad_core/Models/WbAccountModel'
import { StoreProductsTableFilterColumn } from '../../../server/mpsklad_core/Models/StoreProductsTableFilterColumn'

export const WildberriesImportPage =
  observer(
    () => {
      const api = useApi()
      const {productStore: {createWbProductsTable}} = useStore()
      const account = useWbAccount()

      const products = createWbProductsTable(account.id).setPropFilterReadOnly('hasMsProduct', true)

      return (
        <ImportScreen<WbAccountModel, WbProductsTableData, WbProductModel, WbProductColumnId, typeof StoreProductsTableFilterColumn>
          type="Wildberries"
          account={account}
          products={products}
          addProductsFunc={api.import.importProductsWb}
          updateProductsFunc={api.import.updateProductsWb}
          importStocksFunc={api.import.importStocksWb}
          TableComponent={WbProductImportTable}
        />
      )
    })